// its use folder name
const moduleOrder = [
  "dashboard",
  "activities",
  "stock-management",
  "distribution",
  "master",
];
export default moduleOrder;



// WEBPACK FOOTER //
// ./src/modules/_order.js